export default "__VITE_ASSET__ClhlGGXp__"